import {
  FilterOperator,
  FilterType,
  type IOperatorConfig,
} from './filter.types';

/**
 * Configuration for each filter operator
 */
export const OPERATOR_CONFIG: Record<FilterOperator, IOperatorConfig> = {
  [FilterOperator.Eq]: { label: 'Equals', requiresValue: true },
  [FilterOperator.NEq]: { label: 'Not equals', requiresValue: true },
  [FilterOperator.Gt]: { label: 'Greater than', requiresValue: true },
  [FilterOperator.Lt]: { label: 'Less than', requiresValue: true },
  [FilterOperator.GtE]: { label: 'Greater than or equal', requiresValue: true },
  [FilterOperator.LtE]: { label: 'Less than or equal', requiresValue: true },
  [FilterOperator.BgnW]: { label: 'Begins with', requiresValue: true },
  [FilterOperator.EndW]: { label: 'Ends with', requiresValue: true },
  [FilterOperator.NBgnW]: { label: 'Not begins with', requiresValue: true },
  [FilterOperator.NEndW]: { label: 'Not ends with', requiresValue: true },
  [FilterOperator.Cnt]: { label: 'Contains', requiresValue: true },
  [FilterOperator.NCnt]: { label: 'Not contains', requiresValue: true },
  [FilterOperator.NNul]: { label: 'Not null', requiresValue: false },
  [FilterOperator.In]: { label: 'In', requiresValue: true },
  [FilterOperator.NIn]: { label: 'Not in', requiresValue: true },
};

/**
 * Default operators by data type
 */
export const DEFAULT_TOGGLE_LABELS = { on: 'True', off: 'False' } as const;

export const OPERATORS_BY_TYPE: Record<FilterType, FilterOperator[]> = {
  [FilterType.String]: [
    FilterOperator.Eq,
    FilterOperator.NEq,
    FilterOperator.Cnt,
    FilterOperator.NCnt,
    FilterOperator.BgnW,
    FilterOperator.EndW,
    FilterOperator.NBgnW,
    FilterOperator.NEndW,
    FilterOperator.NNul,
  ],
  [FilterType.Number]: [
    FilterOperator.Eq,
    FilterOperator.NEq,
    FilterOperator.Gt,
    FilterOperator.Lt,
    FilterOperator.GtE,
    FilterOperator.LtE,
    FilterOperator.NNul,
    FilterOperator.In,
    FilterOperator.NIn,
  ],
  [FilterType.Date]: [FilterOperator.GtE, FilterOperator.LtE],
  [FilterType.GeoBounds]: [FilterOperator.Eq],
  [FilterType.Boolean]: [FilterOperator.Eq, FilterOperator.NEq],
  [FilterType.Lookup]: [
    FilterOperator.Eq,
    FilterOperator.NEq,
    FilterOperator.NNul,
  ],
};
